import CheckIcon from "@material-ui/icons/Check";
import { Box, Grid, Typography, makeStyles } from "@material-ui/core";

import { COLORS } from "../../../theme/colors";

export const Steps = {
  downloadTemplate: 0,
  updateData: 1,
  confirm: 2,
  reviewCalculation: 3,
};

const useStyles = makeStyles(() => ({
  indicator: {
    transition: "background-color 0.4s ease-in-out",
  },
  doneIcon: {
    padding: 2,
    background: COLORS.purple,
    fill: COLORS.white,
    position: "absolute",
    left: "42%",
    top: "-80%",
    borderRadius: "50%",
  },
}));

const Indicator = ({ borderEdge, active, isDone }) => {
  const classes = useStyles();

  return (
    <Box
      className={classes.indicator}
      mb={2}
      width={131}
      minWidth="100%"
      height={10}
      bgcolor={active ? COLORS.purple : COLORS.darks[0][10]}
      position="relative"
      borderRadius={
        borderEdge === "left"
          ? "5px 0px 0px 5px"
          : borderEdge === "right"
          ? "0px 5px 5px 0px"
          : undefined
      }
    >
      {isDone && <CheckIcon className={classes.doneIcon} />}
    </Box>
  );
};

export const StepBar = ({
  stepNames = ["Download template", "Upload data", "Confirm", "Review calculations"],
  currentStep = Steps.downloadTemplate,
  isCurrentStepDone = false,
}) => {
  return (
    <Grid container justifyContent="center">
      {stepNames.map((stepName, i) => (
        <Grid key={i} item style={{ width: "fit-content", padding: 2 }}>
          <Indicator
            active={i <= currentStep}
            isDone={i < currentStep || (currentStep === i && isCurrentStepDone)}
            borderEdge={i === 0 ? "left" : i === 3 ? "right" : undefined}
          />
          <Typography align="center" color={currentStep == i ? "primary" : undefined}>
            {stepName}
          </Typography>
        </Grid>
      ))}
    </Grid>
  );
};
